var maxTextWidth = "75ch";
var navMinHeight = "58px";
var bgColor = "bgColors.primary";
var maxFormWidth = "430px";
var maxContentWidth = "1400px";
var contentPaddingHorizontal = "extraLarge";
var contentPaddingHorizontalMobile = "medium";
export var SCREEN_CONFIG = {
  bgColor: bgColor,
  maxFormWidth: maxFormWidth,
  maxTextWidth: maxTextWidth,
  maxContentWidth: maxContentWidth,
  navMinHeight: navMinHeight,
  contentPaddingHorizontal: contentPaddingHorizontal,
  contentPaddingHorizontalMobile: contentPaddingHorizontalMobile
};